

export enum ComponentDataType {
    STRING = "string",
    NUMBER = "number",
    DATE = "date"
}